import moment from 'moment';

export const CHANGE_HISTORY_FEATURE_RELEASE_DATE = '28/11/2023';

export type ChangeHistoryFilterFormValues = {
  user_modifier: string;
  dates: string[];
};

export const initialChangeHistoryFilter: ChangeHistoryFilterFormValues = {
  user_modifier: '',
  dates: [moment().subtract(6, 'days').format('DD/MM/YYYY'), moment().format('DD/MM/YYYY')],
};

const today = moment();

export const calendarPreset = [
  {
    id: 'week',
    text: '7 dias',
    start: moment().subtract(6, 'days'),
    end: today,
  },
  {
    id: 'month',
    text: '30 dias',
    start: moment().subtract(29, 'days'),
    end: today,
  },
  {
    id: 'threeMonth',
    text: '90 dias',
    start: moment().subtract(89, 'days'),
    end: today,
  },
  {
    id: 'sixMonth',
    text: '180 dias',
    start: moment().subtract(179, 'days'),
    end: today,
  },
];

export const initialPagination = {
  page: 0,
  perPage: 10,
};

export type ProductData = {
  id: number;
  title: string;
};
